module.exports = __webpack_public_path__ + "images/icons/psp/climate-controlled/5x15.svg";